
import { Component, Vue, Prop } from 'vue-property-decorator';
import { invoiceStore } from '@/store';
// import { formatPriceValue } from "@/utils";
// formatPriceValue('01/01/2020')

@Component
export default class Authorize extends Vue {
  @Prop(Object) readonly item;

  public headers = [
    {
      text: 'Produto',
      sortable: true,
      value: 'item_name',
      align: 'left',
    },
    {
      text: 'Quantidade',
      sortable: true,
      value: 'T012_Quantidade',
      align: 'left',
    },
    {
      text: 'Valor Unitário',
      sortable: true,
      value: 'T012_ValorUnitario',
      align: 'left',
    },
    {
      text: 'Valor Total',
      sortable: true,
      value: 'valor_total',
      align: 'left',
    },
  ];

  public dialog = false;

  public password = '';

  public get invoiceItems() {
    return invoiceStore.invoiceItems;
  }

  public async show(id) {
    let form: any = this.$refs.authorize;
    form.show(id);
    // await invoiceStore.getInvoiceItems(id);
    this.dialog = true;
  }
}
